export default __webpack_public_path__ + "static/media/3.01a36813.JPG";